export enum KeyFocusEnum {
  'header' = 'header',
  'scheduled-filters' = 'scheduled-filters',
  'orders-list' = 'orders-list',
  'consolidate-list' = 'consolidate-list',
  'confirm-modal' = 'confirm-modal',
  'side-bar' = 'side-bar',
  'display-selection' = 'display-selection',
}
